import {
  velvetPourPreview,
  edgeAiPreview,
  redefineGamingPreview,
  comfyPreview,
  weddingPreview,
  colorGeneratorPreview,
  stageCoachPreview,
  foodOrderPreview,
} from "../constants";

export const work = [
  {
    redirect: "https://tahir29.github.io/velvetPour/", 
    preview: velvetPourPreview,
    title: "Velvet Pour",
    description:
      "Velvet Pour is a fresh, visually pleasing showcase built with Vite, GSAP, and Tailwind CSS. It features a smooth scroll-triggered video animation and a custom slider that fluidly highlights content. With Tailwind powering the clean layout and GSAP delivering polished transitions, the site offers an immersive, modern experience.",
  },
  {
    redirect: "https://tahir29.github.io/edgeAI/",
    preview: edgeAiPreview,
    title: "Edge AI",
    description:
      "Edge AI is a sleek, responsive site built with Vite and Tailwind CSS, featuring a smooth light/dark theme toggle. It combines clean design, fast performance, and user-friendly interaction to showcase modern front-end development skills.",
  },
  {
    redirect: "https://tahir29.github.io/redefineGaming/",
    preview: redefineGamingPreview,
    title: "Redefine Gaming",
    description:
      "Redefine Gaming is a sleek, interactive gaming showcase built with modern web tools like Vite, GSAP, and Tailwind CSS. This site features eye-catching animations, seamless transitions, and responsive design—all crafted to immerse visitors in a dynamic, polished experience. Tailwind CSS ensures a clean and efficient layout, while GSAP brings fluid, attention-grabbing effects that elevate every interaction.",
  },
  {
    // redirect: "https://comfy-sloth-new.netlify.app/",
    redirect: "https://tahir29.github.io/comfySloth/",
    preview: comfyPreview,
    title: "Comfy Sloth",
    description:
      "Comfy Sloth is an innovative React-based e-commerce project, designed to offer users a seamless shopping experience. With its intuitive interface, users can effortlessly browse through a diverse range of products, equipped with handy filters to refine their search and find the perfect item.",
  },
  {
    redirect: "https://tahir29.github.io/ReactWedding/",
    preview: weddingPreview,
    title: "Wedding",
    description:
      "Welcome to the official wedding website. Here, you'll find everything you need to know about the upcoming celebration of love. From the heartfelt ceremony and lively reception details to travel suggestions, It's all here.",
  },
  {
    redirect: "https://tahir29.github.io/color-generator/",
    preview: colorGeneratorPreview,
    title: "Color Generator",
    description:
      "The Color Generator application is a handy tool designed to assist users in exploring a range of shades within a specific color family. It lets users input a hex color code and instantly generates 10 darker and 10 lighter shades within the same color family. Ideal for designers and enthusiasts, it streamlines color exploration and aids in precise palette selection for various projects.",
  },
  {
    redirect: "https://www.montereystagecoachlodge.com/",
    preview: stageCoachPreview,
    title: "Monterey Stage Coach Lodge",
    description:
      "I coded out the website at INNsight for the Stage Coach Lodge Hotel, located in Monterey, California. The Stage Coach Lodge is a boutique lodge located right off of Highway 1 in Downtown Monterey. The Stage Coach Lodge offers easy access to the various tourist attractions located in and around the Peninsula.",
  },
  {
    redirect: "https://tahir29.github.io/Food-Order/",
    preview: foodOrderPreview,
    title: "Food Order",
    description:
      "I have developed my initial React application, incorporating CRUD operations and gaining proficiency in utilizing a range of hooks to create a resilient and feature-rich application.",
  },
];
